// extracted by mini-css-extract-plugin
export default {"title":"Iba-z","warning":"Jba-z","sizeOptionsLegendText":"Kba-z"};